import React, { Component } from 'react';
import * as Http from '../../http'
import * as Business from '../../utils/business'
import Loading from '../../components/Loading'
import { MenuItem, DropdownButton } from 'react-bootstrap';


const defaultData = {
  'PD': {
    '1': { id: 1, formula: '= max(pd_value, 0.03%)' }
  },
  'LGD': {
    '1': { id: 1, party_type: '1', ltv: '<60%', estimated_lgd: '30%' },
    '2': { id: 2, party_type: '1', ltv: '60% - 80%', estimated_lgd: '45%' },
    '3': { id: 3, party_type: '1', ltv: '>80%', estimated_lgd: '50%' },
    '4': { id: 4, party_type: '2', ltv: '<60%', estimated_lgd: '55%' },
    '5': { id: 5, party_type: '2', ltv: '60% - 80%', estimated_lgd: '75%' },
    '6': { id: 6, party_type: '2', ltv: '>80%', estimated_lgd: '83%' },
    '7': { id: 7, party_type: '3', ltv: '<60%', estimated_lgd: '35%' },
    '8': { id: 8, party_type: '3', ltv: '60% - 80%', estimated_lgd: '65%' },
    '9': { id: 9, party_type: '3', ltv: '>80%', estimated_lgd: '77%' }
  },
  'EAD': {
    '1': { id: 1, classification: 'Revolving', formula: '= xx_n_eop_bal_lcy + xx_n_undrawn_amount_lcy*CCF' },
    '2': { id: 2, classification: 'Non_revolving', formula: '= xx_n_eop_bal_lcy + xx_n_undrawn_amount_lcy' },
  }
};

export default class ConfigComponents extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      data: defaultData,
      component: 'PD',
      showDeleteAlert: false
    }
    this.usernameWillDelete = null
  }

  componentDidMount() {
    // do something
  }

  onUpdateData = () => {
    this.setState({
      loading: true
    }, () => {
      setTimeout(() => {
        this.setState({ loading: false });
      }, 500)
    })
  }

  renderPD = () => {
    const listRender = [];
    const dicPd = this.state.data && this.state.data['PD'] ? this.state.data['PD'] : {};
    for (const key in dicPd) {
      const obj = dicPd[key];
      const div = (
        <tr key={obj.id}>
          <td>{'PD'}</td>
          <td>
            <input type="text" value={obj.formula} onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const row = data['PD'][key];
              row.formula = event.target.value;
              data['PD'][key] = row
              this.setState({ data })
            }} />
          </td>
        </tr>
      );
      listRender.push(div);
    }
    return (
      <table className="table table-hover table-striped">
        <thead>
          <tr>
            <th>Component</th>
            <th>Formula</th>
          </tr>
        </thead>
        <tbody>
          {listRender}
        </tbody>
      </table>
    );
  }

  renderLGD = () => {
    const listRender = [];
    const dicLGD = this.state.data && this.state.data['LGD'] ? this.state.data['LGD'] : {};
    for (const key in dicLGD) {
      const obj = dicLGD[key];
      const div = (
        <tr key={obj.id}>
          <td>{'LGD'}</td>
          <td>
            <input type="text" value={obj.party_type} onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const row = data['LGD'][key];
              row.party_type = event.target.value;
              data['LGD'][key] = row
              this.setState({ data })
            }} />
          </td>
          <td>
            <input type="text" value={obj.ltv} onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const row = data['LGD'][key];
              row.ltv = event.target.value;
              data['LGD'][key] = row
              this.setState({ data })
            }} />
          </td>
          <td>
            <input type="text" value={obj.estimated_lgd} onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const row = data['LGD'][key];
              row.estimated_lgd = event.target.value;
              data['LGD'][key] = row
              this.setState({ data })
            }} />
          </td>
        </tr>
      );
      listRender.push(div);
    }
    return (
      <table className="table table-hover table-striped">
        <thead>
          <tr>
            <th>Component</th>
            <th>Party Type</th>
            <th>LTV</th>
            <th>Estimated LGD</th>
          </tr>
        </thead>
        <tbody>
          {listRender}
        </tbody>
      </table>
    );
  }

  renderEAD = () => {
    const listRender = [];
    const dicEAD = this.state.data && this.state.data['EAD'] ? this.state.data['EAD'] : {};
    for (const key in dicEAD) {
      const obj = dicEAD[key];
      const div = (
        <tr key={obj.id}>
          <td>{'EAD'}</td>
          <td>
            <input type="text" value={obj.classification} onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const row = data['EAD'][key];
              row.classification = event.target.value;
              data['EAD'][key] = row
              this.setState({ data })
            }} />
          </td>
          <td>
            <input type="text" style={{ width: '500px' }} value={obj.formula} onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const row = data['EAD'][key];
              row.formula = event.target.value;
              data['EAD'][key] = row
              this.setState({ data })
            }} />
          </td>
        </tr>
      );
      listRender.push(div);
    }
    return (
      <table className="table table-hover table-striped">
        <thead>
          <tr>
            <th>Component</th>
            <th>Classification</th>
            <th>Formula</th>
          </tr>
        </thead>
        <tbody>
          {listRender}
        </tbody>
      </table>
    );
  }

  handleSelectComponent = (eventKey, event) => {
    const data = JSON.parse(JSON.stringify(this.state.data));
    this.setState({ component: eventKey });
  }

  render() {
    if (this.state.loading) return <div style={{ height: Business.getHeightContent() }}><Loading size="small" /></div>
    let listRender = null;
    if (this.state.component == 'PD') {
      listRender = this.renderPD();
    } else if (this.state.component == 'LGD') {
      listRender = this.renderLGD();
    } else if (this.state.component == 'EAD') {
      listRender = this.renderEAD();
    }

    return (
      <div className="card">
        <div className="header">
          <div>
            <h4 className="title">Components</h4>
            <div>
              <div style={{ display: 'inline' }}>
                <DropdownButton
                  title={this.state.component}
                  bsSize="small"
                  id={`dropdown-size-${1}`}
                >
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectComponent(eventKey, event); }} eventKey="PD">PD</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectComponent(eventKey, event); }} eventKey="LGD">LGD</MenuItem>
                  <MenuItem divider />
                  <MenuItem onSelect={(eventKey, event) => { this.handleSelectComponent(eventKey, event); }} eventKey="EAD">EAD</MenuItem>
                  <MenuItem divider />
                </DropdownButton>
              </div>

              <button type="button" style={{ display: 'inline', float: 'right' }} className="btn btn-primary" onClick={() => {
                this.onUpdateData();
              }}>Update</button>
            </div>
          </div>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          {listRender}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Config/ConfigComponents.js